function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var React = require('react');

var T = require('prop-types');

var _require = require('react-router'),
    Switch = _require.Switch,
    Route = _require.Route,
    Redirect = _require.Redirect;

var internals = {};

exports.Routes = /*#__PURE__*/function (_React$Component) {
  _inherits(Routes, _React$Component);

  function Routes() {
    _classCallCheck(this, Routes);

    return _possibleConstructorReturn(this, _getPrototypeOf(Routes).apply(this, arguments));
  }

  _createClass(Routes, [{
    key: "render",
    value: function render() {
      var routes = this.props.routes;
      var renderRoute = internals.renderRoute('/');
      return Array.isArray(routes) ? React.createElement(Switch, null, routes.map(renderRoute)) : renderRoute(routes);
    }
  }]);

  return Routes;
}(React.Component);

exports.Routes.propTypes = {
  routes: T.oneOfType([T.object, T.arrayOf(T.object)]).isRequired
};

internals.renderRoute = function (basePath) {
  return function (route) {
    if (route.redirect) {
      // Redirect is special and must be exclusive of other props
      var redirect = route.redirect,
          rest = _objectWithoutProperties(route, ["redirect"]);

      if (Object.keys(rest).length !== 0) {
        throw new Error("No other properties are allowed alongside \"redirect\" in route configuration. Check childRoutes of \"".concat(basePath, "\"."));
      }

      var from = redirect.from,
          to = redirect.to;

      var redirectProps = _objectSpread2({}, redirect);

      if (typeof from === 'string') {
        // redirect.from must be relative
        redirectProps.from = internals.concatPaths(basePath, from);
      }

      if (typeof to === 'string') {
        // If redirect.to is absolute, leave it be. Otherwise make it relative
        redirectProps.to = to.startsWith('/') ? to : internals.concatPaths(basePath, to);
      } else if (to && typeof to.pathname === 'string') {
        // to is an object
        redirectProps.to = _objectSpread2({}, redirectProps.to, {
          pathname: to.pathname.startsWith('/') ? to.pathname : internals.concatPaths(basePath, to.pathname)
        });
      }

      return React.createElement(Redirect, redirectProps);
    }

    var normalizedPath = internals.concatPaths(basePath, route.path);
    var renderRoute = internals.renderRoute(normalizedPath);
    var RouteComponent = route.component || route.render;
    var RouteComponentLifecycleWrapper = internals.RouteComponentLifecycleWrapper;
    return React.createElement(Route, {
      key: route.path,
      path: normalizedPath,
      exact: route.exact,
      strict: route.strict,
      sensitive: route.sensitive,
      render: function render(props) {
        var switcher = route.childRoutes ? React.createElement(Switch, {
          children: route.childRoutes.map(renderRoute)
        }) : null;
        var routeComponent = RouteComponent ? React.createElement(RouteComponent, _extends({}, props, {
          route: route,
          children: switcher
        })) : switcher;
        return RouteComponentLifecycleWrapper.nonTrivial(route) ? React.createElement(RouteComponentLifecycleWrapper, _extends({}, props, {
          route: route,
          children: routeComponent
        })) : routeComponent;
      }
    });
  };
};

internals.RouteComponentLifecycleWrapper = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(RouteComponentLifecycleWrapper, _React$PureComponent);

  function RouteComponentLifecycleWrapper(props) {
    var _this;

    _classCallCheck(this, RouteComponentLifecycleWrapper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RouteComponentLifecycleWrapper).call(this));
    var route = props.route;

    if (route.componentDidCatch) {
      _this.componentDidCatch = function (err, info) {
        return route.componentDidCatch(_objectSpread2({
          err: err,
          info: info
        }, _this.props));
      };
    }

    if (route.onWillMount) {
      _this.componentWillMount = function () {
        return route.onWillMount(_this.props);
      };
    }

    if (route.onDidMount) {
      _this.componentDidMount = function () {
        return route.onDidMount(_this.props);
      };
    }

    if (route.onWillUnmount) {
      _this.componentWillUnmount = function () {
        return route.onWillUnmount(_this.props);
      };
    }

    return _this;
  }

  _createClass(RouteComponentLifecycleWrapper, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return RouteComponentLifecycleWrapper;
}(React.PureComponent);

internals.RouteComponentLifecycleWrapper.propTypes = {
  route: T.object.isRequired
};

internals.RouteComponentLifecycleWrapper.nonTrivial = function (route) {
  return route.componentDidCatch || route.onWillMount || route.onDidMount || route.onWillUnmount;
};

internals.concatPaths = function (base, path) {
  base = base.endsWith('/') ? base.slice(0, -1) : base; // /my-path/ -> /my-path

  path = path.startsWith('/') ? path.slice(1) : path; // /my-path -> my-path

  return "".concat(base, "/").concat(path);
};